import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ title, icon, border, bgcolor, id }) => {
    console.log(id, 'id check card')

    const cardStyle = {
        backgroundColor: bgcolor,
        borderColor: border,
        borderWidth: '2px',
        borderRadius: '10px',
        maxWidth: '273px',
        minHeight: '115px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '20px',
        cursor: 'pointer',
        gap: '15px',
        flexWrap: 'wrap',
    };

    return (
            <Link to={`/${id}`} style={cardStyle}>
                <div className="icon">
                    <img src={icon} alt="Icon" />
                </div>
                <div className="content">
                    <h2 className='text-[#2C2C2C] font-semibold text-[20px]'>{title}</h2>
                </div>
            </Link>
    );
};

export default CategoryCard;